import React, { useContext } from 'react'
import { SliderSeasonLabel, WeekSliderCon } from './styles'
import {
  checkSpecialWeek,
  getWeekendRange,
  isIncompleteChampionship,
  logBrazeEvent,
  logEvent,
} from '../../Utils'
import { EventGQL } from '../../Api'
import { Img } from '../Image/Img'
import { Divider } from '../Layout/Spacers/Spacers.styles'
import { colors } from '../consts'
import { SeasonContext } from '../../Context'
import { ANALYTICS_TAGS } from '../../Constants/analytics'

type WeekParams = {
  weekEvents: EventGQL[]
  week: string
  selected: boolean
  page: string
  direction?: 'vertical' | 'horizontal'
  imgObj?: {
    webp: string
    fallback: string
  } | null
  onSelectChange: (week: string) => void
}

export const WeekItem: React.FC<React.PropsWithChildren<WeekParams>> = ({
  weekEvents,
  week,
  page,
  selected = false,
  direction = 'horizontal',
  imgObj,
  onSelectChange,
}) => {
  const special = checkSpecialWeek(weekEvents[0])
  const { incompleteMarkets } = useContext(SeasonContext)!

  const handleSelected = () => {
    onSelectChange(week)
    logEvent(ANALYTICS_TAGS.schedule_week_click, {
      location: weekEvents[0].location,
      section: `${page} Slider`,
    })
    logBrazeEvent(ANALYTICS_TAGS.schedule_week_click, {
      location: weekEvents[0].location,
      section: `${page} Slider`,
    })
  }

  return (
    <>
      {weekEvents.length > 0 && (
        <>
          {weekEvents[0].seasonSegment === 'champseries' && (
            <SliderSeasonLabel>
              <h2>Lexus Championship Series</h2>
            </SliderSeasonLabel>
          )}
          {weekEvents[0].seasonSegment === 'allstar' && (
            <SliderSeasonLabel>
              <h2>All Star</h2>
            </SliderSeasonLabel>
          )}
          {weekEvents[0].week === '1' && (
            <SliderSeasonLabel>
              <h2>Regular Season</h2>
            </SliderSeasonLabel>
          )}
          {weekEvents[0].slugname.includes('quarter') && (
            <SliderSeasonLabel>
              <h2>Playoffs</h2>
            </SliderSeasonLabel>
          )}
          <WeekSliderCon
            selected={selected}
            direction={direction}
            onClick={() => handleSelected()}
          >
            <div className="inner">
              {imgObj && <Img src={imgObj.webp} alt='Week icon' />}
              <div className="textCon">
                <p className="subText">
                  {isIncompleteChampionship(
                    weekEvents[0].slugname,
                    weekEvents[0].week,
                    incompleteMarkets
                  )
                    ? 'TBA'
                    : getWeekendRange(weekEvents, incompleteMarkets)}
                </p>
                <div className="mainText">{weekEvents[0].location}</div>
                {direction !== 'vertical' && special && (
                  <p className="subText">{special}</p>
                )}
              </div>
            </div>
          </WeekSliderCon>
          {weekEvents[0].seasonSegment === 'allstar' && direction === 'vertical' && (
            <Divider h={0.5} background={colors.gray.gray20} />
          )}
        </>
      )}
    </>
  )
}
